// Minnesotaänger Mini App — mobile back navigation.
// v1 (fix-list J): extracted from MiddleHeader so the blur-before-navigate
// order is unit-testable without a full render. On mobile the composer
// must blur first — the on-screen keyboard closes before the column slides
// back and the frosted ChatList shell is revealed.
// New code (not from telegram-tt).

export function handleMobileBack(navigateBack: () => void): void {
  const messageInput = document.querySelector<HTMLTextAreaElement>('#editable-message-text');
  messageInput?.blur();
  navigateBack();
}
